main();

function main() {
    const $search = document.querySelector('#support-search') as HTMLInputElement;
    const $clearBtn = document.querySelector('#support-search-clear') as HTMLButtonElement;
    const $categories = document.querySelectorAll<HTMLElement>('.faq-category');
    const $categoryButtons = document.querySelector('.category-buttons') as HTMLElement;
    const $noResults = document.querySelector('#faq-no-results') as HTMLElement;
    const $clearWrapper = document.querySelector('#faq-clear-search-wrapper') as HTMLElement;
    const $clearLink = document.querySelector('#faq-clear-search') as HTMLAnchorElement;

    function clearSearch() {
        $search.value = '';
        $search.dispatchEvent(new Event('input'));
        $search.focus();
    }

    function filter() {
        const query = $search.value.trim().toLowerCase();

        $clearBtn.classList.toggle('d-none', !query);

        if (!query) {
            $categoryButtons.classList.remove('d-none');
            $noResults.classList.add('d-none');
            $clearWrapper.classList.add('d-none');
            $categories.forEach($cat => {
                $cat.classList.remove('d-none');
                $cat.querySelectorAll<HTMLElement>('.faq-question').forEach($q => {
                    $q.classList.remove('d-none');
                });
            });
            return;
        }

        $categoryButtons.classList.add('d-none');

        let anyVisible = false;

        $categories.forEach($cat => {
            let hasVisible = false;

            $cat.querySelectorAll<HTMLElement>('.faq-question').forEach($q => {
                const questionText = ($q.querySelector('a')?.textContent || '').toLowerCase();
                const answerText = ($q.dataset.answer || '').toLowerCase();
                const matches = questionText.includes(query) || answerText.includes(query);

                $q.classList.toggle('d-none', !matches);
                if (matches) {
                    hasVisible = true;
                }
            });

            $cat.classList.toggle('d-none', !hasVisible);
            if (hasVisible) {
                anyVisible = true;
            }
        });

        $noResults.classList.toggle('d-none', anyVisible);
        $clearWrapper.classList.remove('d-none');
    }

    $search.addEventListener('input', filter);

    $clearBtn.addEventListener('click', clearSearch);

    $clearLink.addEventListener('click', e => {
        e.preventDefault();
        clearSearch();
    });

    document.addEventListener('keydown', e => {
        if (e.key === '/' && document.activeElement !== $search) {
            e.preventDefault();
            $search.focus();
        }
    });
}
